import React from "react";
import { Route, Routes } from "react-router-dom";
import OpsLayout from "./OpsLayout";
import OpsHome from "./OpsHome";
import TenantsList from "./TenantsList";
import TenantDetail from "./TenantDetail";
import TenantPlanForm from "./TenantPlanForm";
import TenantConsumo from "./TenantConsumo";
import TenantContractTermsForm from "./TenantContractTermsForm";
import TenantBillingList from "./TenantBillingList";
import PlanManagement from "./PlanManagement";
import LegalAdmin from "./LegalAdmin";

export default function OpsPage() {
  return (
    <Routes>
      <Route element={<OpsLayout />}>
        <Route index element={<OpsHome />} />
        <Route path="tenants" element={<TenantsList />} />
        <Route path="planes" element={<PlanManagement />} />
        <Route path="tenants/:tenantId" element={<TenantDetail />} />
        <Route path="tenants/:tenantId/plan" element={<TenantPlanForm />} />
        <Route path="tenants/:tenantId/consumo" element={<TenantConsumo />} />
        <Route path="tenants/:tenantId/contrato" element={<TenantContractTermsForm />} />
        <Route path="tenants/:tenantId/billing" element={<TenantBillingList />} />
        <Route path="legal" element={<LegalAdmin />} />
      </Route>
    </Routes>
  );
}
